import React from "react";
import ConstructionPage from "../../components/ConstructionPage";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <>
      <div id="start" className="fantasmaAncora"></div>
      <div id="main">
        <ConstructionPage />
      </div>
    </>
  );
};
